import { render, staticRenderFns } from "./OfferView.vue?vue&type=template&id=16104ade&scoped=true&"
import script from "./OfferView.vue?vue&type=script&lang=js&"
export * from "./OfferView.vue?vue&type=script&lang=js&"
import style0 from "./OfferView.vue?vue&type=style&index=0&id=16104ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16104ade",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBreadcrumbs,VMenu,VTextarea})
